export default "/images/96759cadaa708ce7aebe3f47670d8c9d.avif";